// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img_preview_getting_card[data-v-5c1b32ac] {\n  width: 70%;\n  margin: 0 auto;\n}\n.img_preview_getting_card img[data-v-5c1b32ac] {\n  width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}", ""]);
// Exports
module.exports = exports;
